import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useConversationStore } from '../../ConversationStoreProvider';
import LegacyProductCard from './LegacyProductCard';
import EnhancedProductCard from './EnhancedProductCard';
import { resolveAiSearchConfig } from './aiSearchConfig';
/* eslint-disable react/jsx-props-no-spreading */
const ProductCard = ({ showAddToCart, variantIds, isSingleVariant, isMultiVariant, productFormatting, ...props }) => {
    const conversationStore = useConversationStore();
    // Resolve aiSearchConfig for Enhanced Cards
    // Only pass aiSearchConfig when dual mode is enabled to maintain retrocompatibility
    const isDualModeEnabled = conversationStore?.clientAIConfig?.clientAIUseDualSearch || false;
    const aiSearchConfig = useMemo(() => {
        if (!isDualModeEnabled) {
            return undefined; // Don't pass aiSearchConfig when dual mode is OFF
        }
        const rawConfig = conversationStore?.clientAIConfig?.aiSearchConfig;
        return resolveAiSearchConfig(rawConfig);
    }, [isDualModeEnabled, conversationStore?.clientAIConfig?.aiSearchConfig]);
    const shouldUseLegacyCard = useMemo(() => {
        // Check if productFormatting explicitly requests legacy cards
        if (productFormatting?.useLegacyCards === true) {
            return true;
        }
        // Check if productFormatting explicitly requests enhanced cards
        if (productFormatting?.useLegacyCards === false) {
            return false;
        }
        // Fallback to original logic
        return !conversationStore?.clientAIConfig?.enhancedProductCardEnabled;
    }, [conversationStore, productFormatting]);
    const finalProductFormatting = useMemo(() => ({
        // Set default behavior if not specified
        clickBehavior: 'navigate',
        cursorStyle: 'default',
        cardInteractive: false,
        ...productFormatting, // Override with any specific behavior props
    }), [productFormatting]);
    if (shouldUseLegacyCard) {
        return (_jsx(LegacyProductCard, { showAddToCart: showAddToCart, variantIds: variantIds, isSingleVariant: isSingleVariant, isMultiVariant: isMultiVariant, productFormatting: productFormatting, ...props }));
    }
    return (_jsx(EnhancedProductCard, { ...props, productFormatting: finalProductFormatting, aiSearchConfig: aiSearchConfig }));
};
export default ProductCard;
//# sourceMappingURL=ProductCard.js.map